import { AnyAction } from 'redux';
import { RequestAction } from '@redux-requests/core';
import { actionPrefixer } from 'shared/utils/utils';
import profileMapper from 'shared/utils/api/mappers/profileMapper';

const prefix = actionPrefixer('USER');
/*
    Action Types
*/
export const PING = prefix('PING');
export const LOGOUT = prefix('LOGOUT');

export const CHECK_USER_AUTH = prefix('CHECK_USER_AUTH');
export const CHECK_USER_AUTH_ERROR = prefix('CHECK_USER_AUTH_ERROR');
export const CHECK_USER_AUTH_SUCCESS = prefix('CHECK_USER_AUTH_SUCCESS');

export const FETCH_USER_PROFILE = prefix('FETCH_USER_PROFILE');
export const FETCH_USER_PROFILE_ERROR = prefix('FETCH_USER_PROFILE_FAIL');
export const FETCH_USER_PROFILE_SUCCESS = prefix('FETCH_USER_PROFILE_SUCCESS');

export const FETCH_SOURCE_MAPPINGS = prefix('FETCH_SOURCE_MAPPINGS');


// DEBUG REMOVE
export const DEBUG_REMOVE_TOGGLE_THEME = prefix('DEBUG_REMOVE_TOGGLE_THEME');

export const toggleTheme = (): AnyAction => ({
    type: DEBUG_REMOVE_TOGGLE_THEME,
  });

  
/*
    Actions
*/

export const logout = (): RequestAction => ({
    type: LOGOUT,
    request: {
        method: 'POST',
        url: '/logout',
    },
});

export const checkUserAuth = (): RequestAction => ({
    type: CHECK_USER_AUTH,
    request: {
        method: 'GET',
        url: '/tools/session',
    },
});

export const fetchUserProfile = (): RequestAction => ({
    type: FETCH_USER_PROFILE,
    request: {
        method: 'GET',
        url: '/services/users/profile',
    },
    meta: {
        onSuccess: (response) => profileMapper.mapFromApi!(response),
    },
});

export const ping = (): RequestAction => ({
    type: PING,
    request: {
        method: 'GET',
        url: '/manage/health',
    },
});
